/* 个性化学习目标页面 */
<template>
  <div class="container">
    <div class="container_body">
      <!--header-->
      <div id="header">
        <div class="header-title"
             v-bind:style="{fontSize: changeFontSize() + 'px'}"><span><span :isgrade="isgrade(grade)">{{grade}}</span>年级<span v-if="seminar==0">上</span><span v-else>下</span>册英语期<span
                  v-if="isfinal==0">中</span><span v-else>末</span>复习</span>
        </div>
        <div class="bg"><img src="../../../../static/images/PeasonalizedTarget-background.png"></div>
      </div>

      <!--介绍-->
      <div id="desc">
        <div class="resource intro">
          <p v-if="tips == ''">Hi {{u_name}}，这里是这学期的<span class="highlight">英语期末知识点复习</span>，老师为您整理了每个单元的单元知识点。每个知识点都可以点进去学习页面学习，通过这个复习全方位的提升知识掌握，快点击单元知识进入复习吧！</p>
          <!-- <div v-html="target_desc"></div> -->
          <div v-if="tips"
             style="text-indent: 2px;font-size: 15px"
             v-html="addDiv(tips)"></div>
        </div>
        </div>
      </div>

      <div id="resource-pep">
        <!--人教版各个单元的知识复习，无个性化-->
        <div v-if="units.length > 0" class="resource resource_cartoon">
          <p>
            <span class="resource-title">
              <span class="fa fa-star"></span>
              <strong>单元知识复习</strong>
            </span>
          </p>
          <div class="resource-content">
            <ul>
              <li v-for="(unit,index) in units"
                  :key="index">
                <a @click="content_href_learning('unit')"
                   :href="'/UnitKnowleageReview?u_name='+u_name+'&uid='+uid+'&seminar='+seminar+'&grade='+grade_bak+'&unitid='+unit.id+'&unit_idx='+index+'&sig='+sig">{{unit.parent_name_l2}}</a>
              </li>
            </ul>
          </div>
        </div>

        <!--薄弱知识能力提升，个性化;没有在3-6年级的 和 没有薄弱的都不应该展示这个栏目-->
        <div v-if="weak_status>0 && units.length > 0" class="resource resource_song">
          <p>
            <span class="resource-title">
              <span class="fa fa-star"></span>
              <strong>薄弱专项提升</strong>
            </span>
          </p>
          <div class="resource-content">
            <div class="intro">
              通过您每节课外教反馈和单元诊断情况，老师这边梳理了您在51Talk学习和学校这学期都需要提升的一些薄弱知识点。针对这些薄弱点，老师精心整理了针对您专项提升的个性习题集，在您完成【薄弱知识点复习】后，点击【个性化习题集】做几个题目，我们督促检查下薄弱点是否都掌握咯，努力帮您提升！</div>
            <div style="height:70px">
              <a @click="content_href_learning('weakness')"
                 class="btn"
                 :href="'/WeakKnowledgeREview?u_name='+u_name+'&uid='+uid+'&sig='+sig+'&isfinal='+isfinal"><strong>薄弱知识点复习</strong></a>
              <a @click="content_href_learning('excercise')"
                 class="btn" :href="'http://itextbook.51talkjr.com/paper/knowledgePoint/'+ level_id + '/'+ uid "><strong>个性化习题集</strong></a>
                 <!-- :href="'/WeakKnowledgeREview?uid='+uid">个性化习题集</a> -->
            </div>

          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
// require('@/assets/css/knowleagePointsReview.css')
require('@/assets/css/peasonalized-target.css')
import 'font-awesome/css/font-awesome.css'
import BaseVue from '@/components/BaseVue'

// var homeData = require('../mock/homepage')

export default {
  name: 'knowleagePointsReview',
  extends: BaseVue,
  /* inherit from BaseVue,the para in data can call on above */
  data() {
    return {
      unit_id:'',
      tips: '',
      u_name: '',
      sig: '',
      grade: 1,
      grade_bak: '',
      seminar: '',
      isfinal: '',
      units: [],
      level_id: '123',
      uid:'',
      // target_desc:'<p>但是学习星球正在开发阶段，小5们还在努力寻找最适合您的学习资源，请过段时间再来看看吧！</p>',
      url_params: '',
      weak_status: 1 //学员是否有匹配出来人教版的薄弱的知识点
    }
  },
  computed: {
    tailUrl: function () {
      return this.url_params === '' ? '' : '?' + this.url_params
    }
  },
  created: function () {
    // let u_name = this.$route.params.u_name
    // var homedata = new homeData()
    // this.mockdata = homedata.data
    this.mockdata = {}
    this.uid = this.$route.query.uid
    let url = this.APIHOST + 'pep_unit_list?userid=' + this.uid  //online mode
    // let url = 'http://10.0.2.70:8033/api/cms/pep_unit_list?userid='+this.uid  //test mode
    fetch(url, {
        method: "get",
        mode: "cors",
      })
        .then((res) => res.json())
        .then((data) => {
          if(data.error_code == 10000){
            this.mockdata= data.ret;
            // console.log('this.mockdata',this.mockdata)
            this.grade = this.mockdata.grade
            this.grade_bak = this.grade
            this.isfinal = this.mockdata.isfinal
            this.seminar = this.mockdata.semester
            this.units = this.mockdata.units
            this.level_id =  this.mockdata.level_id
            this.u_name = this.mockdata.username//'Herry'
          } else if(data.ret && data.ret.username) {
            this.u_name = data.ret.username;
          }
          //学员年级不在正常的3到6年级
          if(data.error_code == -10012){
            let tip = '<p>'+this.u_name+'当前还<span class="orange-bold">不在三到六年级</span>，因此还没有期末报告哟！如果年级当前不准确，联系您的班主任或者顾问老师更改后第二天再来看看吧！</p>'
            this.tips = tip
            // this.tips ='<p>当前还<span class="orange-bold">不在三到六年级</span>，因此还没有期末报告哟！如果年级当前不准确，联系您的班主任或者顾问老师更改后第二天再来看看吧！</p>'
          }
          //学员的id错误，无数据
          if(data.error_code == -10011){
            this.tips ='<p>当前的信息已失效，联系您的班主任或者顾问老师找到您的准确id再来看看吧！</p>'
          }
          //学员匹配人教版+CEJ后没有薄弱知识点，理论上薄弱板块无需展现
          if(data.poor_knowledge_code == -10014){
            this.weak_status = 0
          }
          // 增加个性化学习页面埋点，由于fetch无法异步，可能数据没请求到就埋点了
          pindData.add_params({ t: 'FRR.000001' })
          pindData.pind_send( {
            "action": "PG_FINAL_REVIEW_REPORT",
            "user_id": this.uid,
            "grade": this.grade_bak,
            "seminar": this.seminar,
            "is_final": this.isfinal
            } );
        }
      )
    // this.sig = '678e4ad429a24da53e805029f95d87c3adb4ceb3'
    // if (level === undefined || u_name === undefined || sig === undefined) return
    this.sig = this.generateSig(this.uid + '51love')
    // console.log('sig: ' + realSig + '; sig === realSig: ' + (realSig === sig));
    // console.log('checkSig: ' + this.checkSig(uid + level + unit, sig));
    // if (!this.checkSig(uid + level, sig)) return
    this.url_params = this.$route.fullPath.split('?')[1]
    // this.u_name = u_name
  },
  methods: {
    changeFontSize: function () {
      return 18
      // if (window.innerWidth > 500) return 20
      // return parseInt(
      //   375 / (18 + this.u_name.length + this.units.toString().length)
      // )
    },
    content_href_learning: function (type) {
      //点击期末复习报告中的每个子单元页面学习（unit,weakness,exercise）
      let action = 'CK_FINAL_REVIEW_REPORT_' + type.toLocaleUpperCase()
      pindData.pind_send({ action: action, user_id: this.uid, grade: this.grade_bak, is_final: this.isfinal})
    },
    isgrade(grade) {
      // console.log('grade', grade)
      switch (grade) {
        case 3: {
          this.grade = '三'
          break
        }
        case 4: {
          this.grade = '四'
          break
        }
        case 5: {
          this.grade = '五'
          break
        }
        case 6: {
          this.grade = '六'
          break
        }
      }
    },
    // getUrlParam(name) {
    //   //a标签跳转获取参数
    //   var reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    //   var r = window.location.search.substr(1).match(reg)
    //   if (r != null) return r[2]
    //   return null
    // },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/template/target/KnowleagePointsReview.vue